import { Box, InputLabel, Stack, Typography } from "@mui/material"
import type { SxProps, Theme } from "@mui/system"
import { useMemo } from "react"

import styles from "./styles"

type TextActionFormProps = {
  sx?: SxProps<Theme>
  textSx?: SxProps<Theme>
  label?: string
  labelRight?: React.ReactNode
  labelColor?: string
  text: string | React.ReactNode
  textColor?: string
  backgroundColor?: "primary" | "secondary"
  ButtonRight?: React.ReactNode
  size?: "small" | "medium"
}

export default function TextActionForm(props: TextActionFormProps) {
  const TextActionFormMemo = useMemo(() => {
    if (!props?.ButtonRight) {
      return undefined
    }
    return props.ButtonRight
  }, [props])

  const TextActionFormLabel = useMemo(() => {
    if (!props?.label) {
      return undefined
    }

    return (
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <InputLabel sx={{ color: props.labelColor }}>
          <Typography fontSize={props?.size === "small" ? 14 : undefined}>
            {props.label}
          </Typography>
        </InputLabel>
        {props.labelRight}
      </Stack>
    )
  }, [props])

  return (
    <Box
      sx={{
        width: "100%",
        marginTop: "0!important",
        borderTop: "0!important"
      }}
    >
      {TextActionFormLabel}
      <Stack
        sx={{
          ...styles.TextActionFormStack,
          backgroundColor:
            props?.backgroundColor === "secondary" ? "#ededed" : "white",
          p: inputSizePaddingMap.get(props?.size),
          minHeight: "44px",
          ...props?.sx
        }}
        direction={"row"}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <Typography
          color={props.textColor}
          fontSize={props?.size === "small" ? 14 : undefined}
          sx={{
            overflowX: "auto",
            ...props.textSx
          }}
        >
          {props.text}
        </Typography>
        {TextActionFormMemo}
      </Stack>
    </Box>
  )
}

const inputSizePaddingMap = new Map([
  [undefined, "9px 12px 9px 12px!important"],
  ["medium", "9px 12px 9px 12px!important"],
  ["small", "3px 7px 3px 7px!important"]
])
